import react, { Component } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Menu from "./PatientList_CRUD/component/Menu";

import React from "react";
function App() {
  return (
    <div>
      <Menu />
    </div>
  );
}

export default App;
